import React, { forwardRef, useState, useEffect, Fragment } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import { Col, Row, Typography, Button } from 'antd';
import TileButton from 'ReusableComponents/TileButton/TileButton';
import unescape from "lodash/unescape";
import { intToAlpha, fetchResponses, getQuizId, getQuizName, } from 'lib';

function Mask(props:any) {
  let [letter, title] = props.text.split('.');

  return (
    <Row type="flex" justify="center" style={{ padding: 3, flexDirection: 'column', height: '100%', }}>
      <Col style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}>
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          opacity: 0.3,
          zIndex: 0,
        }}/>
        <Typography.Text style={{
          color: '#FF5A00',
          fontFamily: 'AvenirNextLTPro-Bold',
          fontSize: `calc(400%)`,
          zIndex: 1,
        }}>
          {letter}
        </Typography.Text>
        {title && (
          <Typography.Text style={{
            color: '#fff',
            fontFamily: 'AvenirNextLTPro-Bold',
            fontSize: `calc((100% * ${title.length}) / (${title.length} / 1.3))`,
            zIndex: 1,
            wordBreak: title.trim().includes(' ') ? 'normal': 'break-all',
          }}>
            {title}
          </Typography.Text>
        )}
      </Col>
    </Row>
  )
}

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, defaultValue, id, mediaFiles, response } = inputData,
    { getFieldDecorator } = form;
  const [activeButton, setActiveButton] = useState(response);
  const dangerouslySetInnerHTML = unescape(questions[language])

  useEffect(() => {
    if (checkAnswer) {
      onCheckAnswer(id, activeButton, questionsKey);
    }
  }, [checkAnswer]);

  useEffect(() => {
    if (getQuizName()?.includes('China Quiz')) {
      const responses = fetchResponses();
      const quizId = getQuizId();
      if (quizId && quizId in responses && questionsKey in responses[quizId]) {
        setActiveButton(responses[quizId][questionsKey])
      }
    }
  }, []);

  const GridRow = Array(4).fill(null).map((foo, index) => {
    return (
      mediaFiles[index].is_inside ?
      <Col style={{ margin: '8px 0px' }}>
        <TileButton
          src={mediaFiles[index].src}
          title={intToAlpha(index)}
          setActiveButton={()=>setActiveButton(index)}
          index={index}
          activeButton={activeButton}
          correctAnswer={mediaFiles[index].is_answer}
          checkAnswer={checkAnswer}
        />
      </Col> :
      <Col style={{ margin: '8px 0px' }}>
        <TileButton
          src={mediaFiles[index].src}
          title={mediaFiles[index].title}
          setActiveButton={()=>setActiveButton(index)}
          index={index}
          activeButton={activeButton}
          correctAnswer={mediaFiles[index].is_answer}
          checkAnswer={checkAnswer}
        />
        {
          mediaFiles[index].show_title && (
            <>
            {
              mediaFiles[index].src ?
              <Row style={{
                position: 'absolute',
                width: 'calc(100% - 15px)',
                height: '100%',
                top: 0,
                pointerEvents: 'none',
              }} type="flex" justify="center" align="middle">
                <Col span={12}></Col>
                <Col span={12} style={{ height: '100%', }}>
                  <Mask text={mediaFiles[index].title} />
                </Col>
              </Row> :
              null
            }
            </>
          )
        }
      </Col>
    )
  });

  return (
    <Fragment>
      {
        dangerouslySetInnerHTML !== "<p><br></p>" ?
        <Row type="flex" justify="center" align="middle">
          <Col>
            <Title><span dangerouslySetInnerHTML={{__html: dangerouslySetInnerHTML}} /></Title>
          </Col>
        </Row> :
        null
      }
      <Row style={{ textAlign: "center" }} type="flex" justify="center" gutter={[15, 0]}>
        {GridRow[0]}
        {GridRow[1]}
      </Row>
      <Row style={{ textAlign: "center" }} type="flex" justify="center" gutter={[15, 0]}>
        {GridRow[2]}
        {GridRow[3]}
      </Row>
    </Fragment>
  );
});
